const carouselItems = [
  {
    title: '暑期档观影指南',
    desc: '2026年暑期档热门影片大盘点，从动作大片到温情喜剧，一文带你看遍今夏最值得期待的影视作品',
    img: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20collage%20with%20warm%20golden%20sunlight%2C%20movie%20theater%20seats%20in%20warm%20amber%20lighting%2C%20popcorn%20and%20film%20reels%2C%20cinematic%20atmosphere%2C%20soft%20bokeh%2C%20festive%20entertainment%20vibe&width=1200&height=600&seq=carousel-summer-movies&orientation=landscape',
    tag: '观影指南',
  },
  {
    title: '豆瓣高分电影合集',
    desc: '精选豆瓣评分8.5以上的经典佳作，从悬疑到爱情，每一部都值得反复品味的视听盛宴',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20movie%20poster%20wall%20display%20with%20warm%20gallery%20lighting%2C%20golden%20frames%2C%20classic%20film%20aesthetic%2C%20elegant%20composition%2C%20soft%20spotlight%20effects%2C%20museum%20quality%20presentation&width=1200&height=600&seq=carousel-rated-movies&orientation=landscape',
    tag: '高分推荐',
  },
  {
    title: '最新国产剧热播榜',
    desc: '实时追踪各大平台热播国剧，古装、都市、悬疑全覆盖，追剧党必收的最新片单',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20scene%20with%20traditional%20architecture%20and%20warm%20lantern%20lights%2C%20elegant%20composition%2C%20soft%20golden%20hour%20lighting%2C%20cinematic%20depth%20of%20field%2C%20dramatic%20atmosphere&width=1200&height=600&seq=carousel-chinese-dramas&orientation=landscape',
    tag: '热播追踪',
  },
  {
    title: '经典港片修复计划',
    desc: '那些陪伴我们成长的港片经典，高清修复版陆续上线，重温黄金年代的港味光影',
    img: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20cityscape%20at%20night%20with%20neon%20signs%20and%20warm%20street%20lights%2C%20nostalgic%20cinema%20vibe%2C%20wet%20reflective%20pavement%2C%20retro%20film%20grain%20texture%2C%20atmospheric%20urban%20night%20scene&width=1200&height=600&seq=carousel-hk-classics&orientation=landscape',
    tag: '经典回顾',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center">
          焦点专题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">精选影视专题深度推荐</p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group relative rounded-2xl overflow-hidden bg-background-100 cursor-pointer"
            >
              <div className="aspect-[16/9] md:aspect-[2/1] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
              <div className="absolute top-4 left-4">
                <span className="px-3 py-1 text-xs font-semibold text-background-50 bg-accent-500 rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-bold text-background-50 font-heading group-hover:text-primary-300 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-background-50/80 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}